import { useTranslation } from "react-i18next";

import { LabelWrapper, List, Wrapper } from "./TableRow.styled";

export const TableRow = ({ label, value }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <LabelWrapper>
        {label === "Type" ? t("browserInfo.type") : label}
      </LabelWrapper>

      {Array.isArray(value) ? (
        <List>
          {value.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </List>
      ) : (
        <LabelWrapper>{value}</LabelWrapper>
      )}
    </Wrapper>
  );
};
